<template>
  <div class="title-warpper" :class="{ [align]: true }">
    <h2>{{ title }}</h2>
    <p v-if="!!en">{{ en }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    en: {
      type: String,
      default: "",
    },
    align: {
      type: String,
      default: "center",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css

.title-warpper {
  position: relative;
  text-align: center;
  padding-bottom: 16px;
  line-height: 1;
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    width: 38px;
    height: 4px;
    // border-radius: 3px;
    background: $main-color;
  }
  &.left {
    text-align: left;
    &:after {
      left: 0;
    }
  }
  &.center {
    text-align: center;
    &:after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &.right {
    text-align: right;
    &:after {
      right: 0;
    }
  }
  h2 {
    font-size: 36px;
    color: #3d3d3d;
  }
  p {
    margin-top: 12px;
    font-size: 18px;
    color: #3d3d3d;
  }
}
.isMobile {
  .title-warpper {
    padding-bottom: 10px;
    &:after {
      width: 26px;
      height: 3px;
    }
    h2 {
      font-size: 23px;
    }
    p {
      margin-top: 8px;
      font-size: 10px;
    }
  }
}
</style>
